import Services from "services";

class LaporanHPPApi {
  async getList(params) {
    const fetch = await Services.get("/laporan_hpp/page", {
      params,
    });
    return fetch.data;
  }

  async getDropdownBarangJadi(params) {
    const fetch = await Services.get("/dropdown/barang_jadi", {
      params,
    });

    return fetch?.data?.data?.map((val) => ({
      label: val?.nama_item,
      value: val?.id_item_buaso,
    }));
  }

  async getDropdownUnitProduksi(params) {
    const fetch = await Services.get("/dropdown/unit_produksi", {
      params,
    });

    return fetch?.data?.data?.map((val) => ({
      label: val?.nama_unit_produksi,
      value: val?.id_unit_produksi,
    }));
  }

  export(params) {
    return Services.get("/laporan_hpp/export", { params });
  }
}

export default new LaporanHPPApi();
